import { render, staticRenderFns } from "./FileSize.vue?vue&type=template&id=58fee4eb"
import script from "./FileSize.vue?vue&type=script&lang=js"
export * from "./FileSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports